import { h, FunctionComponent } from 'preact';
import { useTranslation } from 'react-i18next';
import { useRating } from 'hooks/useRating';
import { useEffect } from 'preact/hooks';
import Rating from 'components/Rating';
import { GlobalConfig } from 'interfaces/GlobalConfig.interface';
import PmParcel from 'interfaces/PmParcel';
import {
  DEMO_TARGET,
  DEMO_TARGET_ATTRIBUTE,
} from 'constants/demoTarget.constants';
import {
  Container,
  MainBox,
  RatingTitle,
  RatingWrapper,
  ErrorMessage,
} from './RatingOverall.styles';
import RatingModal from './components/RatingModal';
import { usePpRatingParams } from './ParcelDetails.hooks';

interface RatingOverallProps {
  selectedParcel: PmParcel;
  globalConfig: GlobalConfig;
}

const RatingOverall: FunctionComponent<RatingOverallProps> = ({
  selectedParcel,
  globalConfig,
}) => {
  const { t } = useTranslation();
  const { rating, parcelDetailsBox } = globalConfig.config;
  const { shouldRemoveSectionGap } = parcelDetailsBox;
  const {
    rateForShipment,
    currentRate,
    setCurrentRate,
    ratingError,
    shownAdditionalRating,
    closeAdditionalRating,
    isInitializedRating,
  } = useRating(selectedParcel, globalConfig);
  const { ppRating: ratingValue } = usePpRatingParams();

  useEffect(() => {
    if (ratingValue && currentRate && isInitializedRating) {
      rateForShipment(ratingValue);
    }
  }, [ratingValue, currentRate, isInitializedRating]);

  return (
    <div>
      <Container
        shouldRemoveSectionGap={shouldRemoveSectionGap}
        {...{ [DEMO_TARGET_ATTRIBUTE]: DEMO_TARGET.rating }}
      >
        <MainBox>
          <RatingTitle id="rating-question">
            {rating?.mainQuestion || t('RATING_MAIN_QUESTION')}
          </RatingTitle>
          <RatingWrapper>
            <Rating
              value={currentRate?.value ?? 0}
              onChange={(value: number) => {
                rateForShipment(value);
              }}
              ariaLabelledBy="rating-question"
            />
          </RatingWrapper>
          {ratingError && <ErrorMessage>{t('ERROR_MSG_GENERAL')}</ErrorMessage>}
        </MainBox>
      </Container>

      <RatingModal
        isOpen={shownAdditionalRating}
        onClose={closeAdditionalRating}
        globalConfig={globalConfig}
        lastRating={currentRate}
        onRateSuccess={setCurrentRate}
      />
    </div>
  );
};

export default RatingOverall;
